<template>
  <v-container fluid>
    <QuickNavigation :fileData="fileData" :routeHistory="$route" />
    <section>
      <div v-if="!!fileData && !!fileData.embeddedDocs">
        <div>
          <v-text-field
            v-model="search"
            solo
            label="Find your document"
            prepend-inner-icon="mdi-magnify"
            clearable
          ></v-text-field>
          <div v-if="!!search">
            <v-card flat>
              <v-data-table
                class="mt-4 table--bordered elevation-1"
                dense
                :items-per-page="999"
                hide-default-footer
                :headers="[
                  {
                    text: 'Category',
                    value: 'documentCategoryCode',
                    sortable: true,
                  },
                  { text: 'Description', value: 'description', sortable: true },
                  { text: 'Status', value: 'status', sortable: false },
                  { text: 'Created', value: 'dateCreated', sortable: true },
                ]"
                :items="
                  fileData.embeddedDocs.filter(
                    (x) =>
                      (!!search &&
                        !!x.description &&
                        !!x.fileExtension &&
                        `${x.description.toLowerCase()}`.includes(
                          search.toLowerCase()
                        )) ||
                      x.fileExtension.toLowerCase() == search.toLowerCase()
                  )
                "
              >
                <template v-slot:[`item.documentCategoryCode`]="{ item }">
                  {{ item.documentCategoryCode }}
                </template>
                <template v-slot:[`item.description`]="{ item }">
                  <div
                    class="secondary--text"
                    @click="
                      downloadEmbeddedDoc(item.fileDataId, item.embeddedDocId)
                    "
                    style="cursor: pointer"
                  >
                    <v-icon color="secondary" small> mdi-download </v-icon>
                    <span>{{ item.description }}.{{ item.fileExtension }}</span>
                  </div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <div>
                    {{
                      $store.state.byteProEnumList.documentStatus.find(
                        (x) => x.key == item.status
                      ).displayName
                    }}
                  </div>
                </template>
                <template v-slot:[`item.dateCreated`]="{ item }">
                  <div v-if="!!item.dateCreated">
                    {{ item.dateCreated | moment("MM/DD/YYYY HH:mm") }}
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </div>

        <v-card class="pa-4 my-4" flat tile>
          <div class="text-h6 font-weight-bold mr-4">Useful Documents</div>
          <v-divider></v-divider>
          <v-row>
            <v-col
              cols="12"
              md="3"
              v-for="(option, index) in usefulDocsCategory"
              :key="'useful-documents-' + index"
            >
              <v-hover v-slot="{ hover }">
                <v-card
                  class="text-center py-4"
                  :elevation="hover ? 5 : 0"
                  hover
                  tile
                  :color="
                    getFilteredDocuments(option, fileData.embeddedDocs)
                      .length === 0
                      ? 'lightgrey'
                      : 'yellow lighten-3'
                  "
                  :disabled="
                    getFilteredDocuments(option, fileData.embeddedDocs)
                      .length === 0
                  "
                  @click="
                    openDownloadModal(
                      getFilteredDocuments(option, fileData.embeddedDocs)
                    )
                  "
                >
                  <p class="font-weight-black">
                    {{ option.displayName }} ({{
                      getFilteredDocuments(option, fileData.embeddedDocs)
                        .length
                    }})
                  </p>
                  <v-icon> mdi-download </v-icon>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="pa-4 my-4" flat tile>
          <div class="text-h6 font-weight-bold mr-4">Stored Documents</div>
          <v-divider></v-divider>
          <v-row>
            <v-col
              cols="12"
              md="3"
              v-for="(option, index) in this.storedDocsCategoryList"
              :key="'stored-documents-' + index"
            >
              <v-hover v-slot="{ hover }">
                <v-card
                  class="text-center py-4"
                  :elevation="hover ? 5 : 0"
                  hover
                  :color="
                    getFilteredDocuments(option, fileData.embeddedDocs)
                      .length === 0
                      ? 'lightgrey'
                      : 'yellow lighten-3'
                  "
                  :disabled="
                    getFilteredDocuments(option, fileData.embeddedDocs)
                      .length === 0
                  "
                  @click="
                    openDownloadModal(
                      getFilteredDocuments(option, fileData.embeddedDocs)
                    )
                  "
                >
                  <p class="font-weight-black">
                    {{ option.displayName }} ({{
                      getFilteredDocuments(option, fileData.embeddedDocs)
                        .length
                    }})
                  </p>
                  <v-icon> mdi-download </v-icon>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-card>
        <DownloadEmbeddedDocsModal />
        <LoanDetailSubMenu />
      </div>
    </section>
  </v-container>
</template>

<script>
import QuickNavigation from "@/components/QuickNavigation";
import DownloadEmbeddedDocsModal from "@/components/DownloadEmbeddedDocsModal";
import LoanDetailSubMenu from "@/components/LoanDetailSubMenu";
import { common } from "@/mixins";

export default {
  name: "StoredDocument",
  components: {
    QuickNavigation,
    DownloadEmbeddedDocsModal,
    LoanDetailSubMenu,
  },
  async mounted() {
    this.usefulDocsCategory = await this.getUsefulDocsCategoryList();
    this.storedDocsCategoryList = await this.getStoredDocsCategoryList();
    const categories = [
      ...new Set(
        this.usefulDocsCategory
          .map((x) => x.documentCategoryCode)
          .concat(
            this.storedDocsCategoryList.map((x) => x.documentCategoryCode)
          )
      ),
    ];

    const response = await this.$store
      .dispatch("fileDataApi/getFileDataDetail", {
        loanNumber: this.$route.query.loanNumber,
      })
      .then((resp) => resp)
      .catch((err) => err);

    if (response.status === 200) {
      this.fileData = response.data;

      const embeddedDocs = await this.$store
        .dispatch("embeddeddoc/get", {
          fileDataId: this.fileData.fileDataId,
        })
        .then((resp) => resp.data)
        .catch(() => null);

      if (embeddedDocs !== null) {
        if (this.$store.getters["isAdmin"]) {
          this.fileData.embeddedDocs = embeddedDocs.filter((x) =>
            categories.includes((x.documentCategoryCode + "").toUpperCase())
          );
        } else {
          this.fileData.embeddedDocs = embeddedDocs.filter(
            (x) =>
              categories.includes(
                (x.documentCategoryCode + "").toUpperCase()
              ) && x.viewable === true
          );
        }
      }
    } else {
      this.$store.commit("statusDialog/showErrorDialog", response.data);
      this.$router.push("/pipeline");
    }
  },
  data() {
    return {
      search: null,
      fileData: null,
      usefulDocsCategory: null,
      storedDocsCategoryList: null,
      selectedCategory: null,
      dialog: false,
    };
  },
  methods: {
    async getUsefulDocsCategoryList() {
      return [
        {
          documentCategoryCode: "APP",
          documentTypeCode: "UWTransmittal",
          displayName: "1008",
        },
        {
          documentCategoryCode: "APP",
          documentTypeCode: "LoanApp",
          displayName: "1003",
        },
        {
          documentCategoryCode: "CRED",
          documentTypeCode: "CreditReport",
          displayName: "CREDIT REPORT",
        },
        {
          documentCategoryCode: "PROP",
          documentTypeCode: "AppraisalReport",
          displayName: "APPRAISAL",
        },
        {
          documentCategoryCode: "APP",
          documentTypeCode: "RateLockAgr",
          displayName: "LOCK CONFIRMATION",
        },
        {
          documentCategoryCode: "APP",
          documentTypeCode: "AUSFindings",
          displayName: "AUS",
        },
        {
          documentCategoryCode: "APP",
          documentTypeCode: "ApprovalLetter",
          displayName: "APPROVAL",
        },
        {
          documentCategoryCode: "BROKER UPLOADS",
          documentTypeCode: null,
          displayName: "BROKER UPLOADS",
        },
      ];
    },
    async getStoredDocsCategoryList() {
      return [
        { documentCategoryCode: "APP", displayName: "APPLICATIONS" },
        { documentCategoryCode: "DISC", displayName: "DISCLOSURES" },
        { documentCategoryCode: "CRED", displayName: "CREDIT" },
        { documentCategoryCode: "INC", displayName: "INCOME" },
        { documentCategoryCode: "ASSET", displayName: "ASSETS" },
        { documentCategoryCode: "PROP", displayName: "PROPERTY" },
        { documentCategoryCode: "DOCS", displayName: "LOAN DOCS" },
        { documentCategoryCode: "GOV", displayName: "GOVERNMENT" },
        { documentCategoryCode: "TITLE", displayName: "TITLE/ESCROW" },
        { documentCategoryCode: "TRID", displayName: "TRID" },
        { documentCategoryCode: "MISC", displayName: "MISC" },
        { documentCategoryCode: "SERVICING", displayName: "SERVICING" },
      ];
    },
    getFilteredDocuments(option, embeddedDocList) {
      if (option.documentTypeCode) {
        return embeddedDocList.filter(
          (x) =>
            this.compareCaseInsensitive(
              x.documentCategoryCode,
              option.documentCategoryCode
            ) &&
            this.compareCaseInsensitive(
              x.documentTypeCode,
              option.documentTypeCode
            )
        );
      } else {
        return embeddedDocList.filter((x) =>
          this.compareCaseInsensitive(
            x.documentCategoryCode,
            option.documentCategoryCode
          )
        );
      }
    },
    compareCaseInsensitive(a, b) {
      if (a !== null && b !== null) {
        return a.toUpperCase() === b.toUpperCase();
      }
      return false;
    },
    openDownloadModal(embeddedDocs) {
      this.$store.commit("SHOW_EMBEDDEDDOCS_DOWNLOAD_MODAL", embeddedDocs);
    },
    async downloadEmbeddedDoc(fileDataId, embeddedDocId) {
      try {
        const resp = await this.$store
          .dispatch("embeddeddoc/getOne", {
            fileDataId: fileDataId,
            embeddedDocId: embeddedDocId,
          })
          .catch((err) => err);
        if (resp.status > 300) {
          throw resp.data;
        }
        const embeddeddoc = resp.data;
        this.downloadFile(
          embeddeddoc.description,
          embeddeddoc.fileExtension,
          embeddeddoc.documentData
        );
      } catch (err) {
        this.$store.commit("statusDialog/showErrorDialog", err);
      }
    },
  },
  mixins: [common],
};
</script>
